import type { QueryClient } from "@tanstack/react-query";

/**
 * 이름 표시 설정이 바뀐 뒤, 이름이 들어간 채널 쿼리(멤버 목록·내 채널 목록·채널 상세)를 다시 불러오게 한다.
 * 채널 멤버 쿼리는 staleTime이 5분이라 무효화하지 않으면 설정 변경이 바로 보이지 않는다.
 */
export function invalidateMemberNameQueries(
    queryClient: QueryClient,
    companyId: number,
): void {
    void queryClient.invalidateQueries({ queryKey: ["channelMembers", companyId] });
    void queryClient.invalidateQueries({ queryKey: ["myChannels", companyId] });
    void queryClient.invalidateQueries({ queryKey: ["channel", companyId] });
}
